import { useSelector } from 'react-redux'

import { CurrencyNames } from '@webapp/core/entities/external/Currency'
import { makeSelectFeatureSwitches } from '@webapp/core/stores/global'

export const useSpendingCardCurrency = () => {
  const { enable_airwallex_uk, enable_airwallex_ca } = useSelector(
    makeSelectFeatureSwitches()
  )

  const getCurrencyName = () => {
    if (enable_airwallex_ca) return CurrencyNames.CAD
    if (enable_airwallex_uk) return CurrencyNames.GBP
    return CurrencyNames.USD
  }

  return {
    currencyName: getCurrencyName(),
  }
}
